module.exports = __webpack_public_path__ + "img/bg.336cb406.png";